import React, { ReactNode } from 'react';

import './ContainerForm.scss';

export declare type TypeOfColumns = 1 | 2 | 3;
export declare type ContainerFormProps = {
  /** FormContainer id attribute, optional id */
  id?: string;
  /** Content */
  children?: ReactNode;
  /** custom classname */
  className?: string;
  /** Max Columns */
  maxColumns: TypeOfColumns;
};

const ContainerForm = ({
  id,
  children,
  className,
  maxColumns,
}: ContainerFormProps) => {
  const ComponentClassnamePrefix = 'elmo-container-form';
  return (
    <div
      className={`${ComponentClassnamePrefix} ${ComponentClassnamePrefix}--max-columns-${
        maxColumns ?? 2
      } ${className ?? ''}`}
      id={id}
    >
      {children}
    </div>
  );
};

export default ContainerForm;
